import api from "Common/Client/Interceptor";

const getAuthHeaders = () => ({
  accept: "*/*",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const fetchInvites = async (
  selectedRole,
  { pageNumber = 1, pageSize = 10, orderByLatest = false } = {}
) => {
  try {
    const response = await api.get(
      `TenantUserInvites/Admin/GetList?rolesEnum=${selectedRole}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderByLatest=${orderByLatest}`,
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const resendInvite = async (inviteId) => {
  try {
    const response = await api.post(
      `TenantUserInvites/resend-invitation/${inviteId}`,
      null,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendInvite = async (inviteData) => {
  try {
    const response = await api.post(`TenantUserInvites/send-invitation`, inviteData, {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;

  }
};
